
    import '/opt/buildhome/repo/packages/x/docs/react/model-use-qwen.zh-CN.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-react-model-use-qwen-demo-qwen-sdk","docs-react-model-use-qwen-demo-qwen"],
  getter: () => import(/* webpackChunkName: "meta__docs__zh-CN" */'/opt/buildhome/repo/packages/x/docs/react/model-use-qwen.zh-CN.md?type=demo')
};